import { render } from "./shopFirst.vue?vue&type=template&id=efbbfda4"
import script from "./shopFirst.vue?vue&type=script&lang=js"
export * from "./shopFirst.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\loong\\develop\\project\\tianyuan\\ty-maintain-web\\ty-maintain-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__